<template>
  <div :class="{ message: true, 'is-primary': isPurple }">
    <div class="message-body">
      <div class="title-container">
        <p :class="titleClasses">
          {{ date }}
        </p>
        <span v-if="isPurple">
          <a
            @click="resetEditing"
            class="edit has-text-primary"
            v-if="isEditing">
            cancel
          </a>
          <a
            @click="setEditingLine"
            class="edit has-text-primary"
            v-else>
              edit
          </a>
        </span>
      </div>
      <div v-for="(line, index) in lines" :key="line.id">
        <p v-if="showPrompt(line, index)">{{ line.prompt }}</p>
        <p class="subtitle is-5">
          <line-display
            :year="year(line)"
            :text="line.text"
            :image-url="line.imageUrl"
            :id="line.id"
            :sentiment-score="line.sentimentScore"
          />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapMutations } from 'vuex'
import { getYearForLine, groupByDateFormat } from '@/util'
import LineDisplay from './LineDisplay.vue'

export default {
  name: 'DateDisplay',
  props: ['isPurpleable', 'lines', 'date'],
  components: {
    LineDisplay
  },
  computed: {
    ...mapGetters([
      'isEditing',
      'promptForDay'
    ]),
    isPurple() {
      return this.isPurpleable && moment().format(groupByDateFormat) === this.date
    },
    prompt() {
      return this.promptForDay(this.date)
    },
    titleClasses() {
      return {
        title: true,
        'is-6': !this.isPurple,
        'is-2': this.isPurple,
        'is-size-4-mobile': this.isPurple,
        fancy: true
      }
    },
    year: () => getYearForLine
  },
  methods: {
    ...mapMutations([
      'resetEditing',
      'setEditing'
    ]),
    setEditingLine() {
      this.setEditing(this.lines[0])
    },
    showPrompt(line, index) {
      return line.prompt
        && (index === 0 || this.lines[index - 1].prompt !== line.prompt)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.is-2 {
  margin-bottom: .5rem;
}

.message {
  margin: 30px 0;
}

.title-container {
  align-items: baseline;
  display: flex;
}

.edit {
  margin-left: 10px;
}
</style>
